import { apiRequest } from "@/shared/lib/apiClient";

/* Tableaux de bord Admin et Audit : compteurs filtrés par assureur, prestataire, entreprise et package. */

export type DashboardScope = "admin" | "auditor";

export type DashboardFilters = {
  insurer_id: number | null;
  hospital_id: number | null;
  company_id: number | null;
  package_id: number | null;
};

export type DashboardOption = { id: number; name: string };

export type DashboardSummary = {
  filters: DashboardFilters;
  options: { insurers: DashboardOption[]; hospitals: DashboardOption[]; companies: DashboardOption[]; packages: DashboardOption[] };
  invoices: { total: number; submitted: number; in_review: number; approved: number; rejected: number; approved_amount: number };
  requests: { total: number; pending: number; approved: number; rejected: number };
};

export const EMPTY_FILTERS: DashboardFilters = { insurer_id: null, hospital_id: null, company_id: null, package_id: null };

export async function fetchDashboardSummary(scope: DashboardScope, filters: DashboardFilters): Promise<DashboardSummary> {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value) params.set(key, String(value));
  }
  const qs = params.toString();
  return apiRequest<DashboardSummary>(`/${scope}/dashboard/summary${qs ? `?${qs}` : ""}`, { auth: true });
}
